import { render, staticRenderFns } from "./TouchReservationMain.vue?vue&type=template&id=f556fd80&scoped=true&"
import script from "./TouchReservationMain.vue?vue&type=script&lang=js&"
export * from "./TouchReservationMain.vue?vue&type=script&lang=js&"
import style0 from "./TouchReservationMain.vue?vue&type=style&index=0&id=f556fd80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f556fd80",
  null
  
)

export default component.exports